/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_gloves_condition_of_use = /** @type {(inputs: {}) => string} */ () => {
	return `Podmínky používání`
};

const da_attributes_gloves_condition_of_use = /** @type {(inputs: {}) => string} */ () => {
	return `Brugstilstand`
};

const de_attributes_gloves_condition_of_use = /** @type {(inputs: {}) => string} */ () => {
	return `Bedingung für die Verwendung`
};

const en_attributes_gloves_condition_of_use = /** @type {(inputs: {}) => string} */ () => {
	return `Condition of use`
};

const es_attributes_gloves_condition_of_use = /** @type {(inputs: {}) => string} */ () => {
	return `Condiciones de uso`
};

const fr_attributes_gloves_condition_of_use = /** @type {(inputs: {}) => string} */ () => {
	return `Conditions d'utilisation`
};

const hu_attributes_gloves_condition_of_use = /** @type {(inputs: {}) => string} */ () => {
	return `Használati Feltétel`
};

const it_attributes_gloves_condition_of_use = /** @type {(inputs: {}) => string} */ () => {
	return `Condizioni di utilizzo`
};

const nl_attributes_gloves_condition_of_use = /** @type {(inputs: {}) => string} */ () => {
	return `Gebruiksconditie`
};

const pl_attributes_gloves_condition_of_use = /** @type {(inputs: {}) => string} */ () => {
	return `Warunek użycia`
};

const pt_attributes_gloves_condition_of_use = /** @type {(inputs: {}) => string} */ () => {
	return `Condições de utilização`
};

const sv_attributes_gloves_condition_of_use = /** @type {(inputs: {}) => string} */ () => {
	return `Villkor för användning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_gloves_condition_of_use = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_gloves_condition_of_use(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_gloves_condition_of_use", locale)
	if (locale === "cs") return cs_attributes_gloves_condition_of_use(inputs)
	if (locale === "da") return da_attributes_gloves_condition_of_use(inputs)
	if (locale === "de") return de_attributes_gloves_condition_of_use(inputs)
	if (locale === "en") return en_attributes_gloves_condition_of_use(inputs)
	if (locale === "es") return es_attributes_gloves_condition_of_use(inputs)
	if (locale === "fr") return fr_attributes_gloves_condition_of_use(inputs)
	if (locale === "hu") return hu_attributes_gloves_condition_of_use(inputs)
	if (locale === "it") return it_attributes_gloves_condition_of_use(inputs)
	if (locale === "nl") return nl_attributes_gloves_condition_of_use(inputs)
	if (locale === "pl") return pl_attributes_gloves_condition_of_use(inputs)
	if (locale === "pt") return pt_attributes_gloves_condition_of_use(inputs)
	return sv_attributes_gloves_condition_of_use(inputs)
};
export { attributes_gloves_condition_of_use as "attributes.gloves_condition_of_use" }